import Button from '@mui/material/Button/Button';
import { styled } from 'styled-components';

export const ButtonStyled = styled(Button)``;
export default ButtonStyled;
